const projects = [
  {
    title: "Craton",
    year: 2026,
    link: "https://github.com/zaynchow",
    description:
      "A platform that detects and visualizes consistency gaps between design systems and production code, helping engineering teams maintain UI integrity at scale. Built with Next.js 15, NestJS, PostgreSQL, BullMQ, and Redis in a Turborepo monorepo with async job processing.",
  },
  {
    title: "FlowFrame",
    year: 2025,
    link: "https://github.com/zaynchow",
    description:
      "AI-powered agile project management platform with a MERN stack and a FastAPI ML microservice for sprint planning and task assignment. Used sentence-transformers and cosine similarity to match tasks by skill, experience, and workload. Fully Dockerized with one-command deployment via Docker Compose.",
  },
  {
    title: "Momen Real Estates",
    year: 2025,
    link: "https://github.com/zaynchow",
    description:
      "Responsive real estate listing platform with live Google Maps integration, server-side rendering, and CMS-driven content via Sanity.io. Built with Next.js.",
  },
  {
    title: "HAB Securities Corporate Website",
    year: 2023,
    link: "https://habsecurities.com/",
    description:
      "Minimal corporate website for a leading securities company with CMS-managed content, performance-optimized with Next.js and Sanity.io.",
  },
  {
    title: "Spotify Analytics App",
    year: 2022,
    link: "https://spotify-app-frontend.vercel.app/",
    description:
      "A web app for visualizing personalized Spotify data built with React, Express, and the Spotify API. Features OAuth 2.0, top tracks and artists, and audio feature visualization.",
  },
  {
    title: "Sanity E-commerce App with Stripe",
    year: 2022,
    link: "https://sanity-full-stack-e-commerce.vercel.app",
    description:
      "Full-featured e-commerce app built with Next.js, leveraging SSR and SSG for fast dynamic pages, Sanity for content management, and Stripe as a payment gateway.",
  },
  {
    title: "CommerceCart",
    year: 2021,
    link: "https://github.com/zaynchow/CommerceCart",
    description:
      "Full-fledged e-commerce store with an admin dashboard for consumer analytics, built with React.",
  },
];

export default projects;
